/* Buscador con sugerencias y foto (Luis 2026-09-18, prototipo aprobado). Se engancha a todo
   input[name=q] dentro de un formulario de búsqueda. Usa /search/suggest.json (búsqueda predictiva de
   Shopify). El "+" pide /products/<handle>.js para la primera variante disponible y agrega con /cart/add.js;
   luego reescribe .cart-counter (lo observa sd-shipping-progress.js) y avisa a sdCarrito. */
(() => {
  const root = window.Shopify?.routes?.root || '/';
  const POPULARES = ['GHOST', 'Flamin Hot', 'Pumpkin spice', 'OREO', 'Pop-Tarts', 'Takis'];
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const pesos = (p) => '$' + Math.round(parseFloat(p)).toLocaleString('es-MX');
  const norm = (s) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  const img = (u) => u ? u + (u.includes('?') ? '&' : '?') + 'width=120' : '';
  const handle = (url) => { try { return new URL(url, location.origin).pathname.split('/products/')[1]?.split('/')[0]; } catch (_) { return null; } };
  const marca = (txt, q) => {
    let out = esc(txt);
    norm(q).split(/\s+/).filter((w) => w.length > 1).forEach((w) => {
      const i = norm(out).indexOf(w);
      if (i >= 0 && !/[<>]/.test(out.slice(i, i + w.length))) out = out.slice(0, i) + '<mark>' + out.slice(i, i + w.length) + '</mark>' + out.slice(i + w.length);
    });
    return out;
  };

  document.querySelectorAll('form[role="search"] input[name="q"], form[action*="/search"] input[name="q"]').forEach((input, n) => {
    const form = input.form;
    if (!form || form.dataset.sdSug) return;
    form.dataset.sdSug = '1';
    form.classList.add('sds-form');
    const caja = document.createElement('div');
    caja.className = 'sds'; caja.id = `sds-${n}`; caja.hidden = true; caja.setAttribute('role', 'listbox');
    input.setAttribute('aria-controls', caja.id); input.setAttribute('aria-autocomplete', 'list'); input.setAttribute('autocomplete', 'off');
    form.appendChild(caja);
    let t, ultima = '', ctrl;

    const vacio = () => {
      caja.innerHTML = `<div class="sds-tit">Lo más buscado</div><div class="sds-pop">${POPULARES.map((p) => `<button type="button" class="sds-chip" data-pop="${esc(p)}">${esc(p)}</button>`).join('')}</div>`;
      caja.hidden = false;
    };
    async function busca() {
      const q = input.value.trim();
      if (!q) { vacio(); return; }
      if (q === ultima && !caja.hidden) return;
      ultima = q; ctrl?.abort(); ctrl = new AbortController();
      try {
        const r = await fetch(`${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide`, { signal: ctrl.signal, headers: { Accept: 'application/json' } });
        const d = await r.json();
        const ps = d.resources?.results?.products || [];
        if (input.value.trim() !== q) return;
        caja.innerHTML = ps.length
          ? ps.map((p) => { const [nom, , ...resto] = p.title.split(' · '); return `<div class="sds-it" role="option"><a class="sds-ab" href="${esc(p.url)}"><span class="sds-ph">${p.image ? `<img src="${esc(img(p.image))}" alt="" loading="lazy">` : ''}</span><span class="sds-tx"><span class="sds-n">${marca(nom, q)}</span><span class="sds-p"><b>${pesos(p.price)}</b>${resto.length ? ' · ' + esc(resto.join(' · ')) : ''}</span></span></a><button type="button" class="sds-mas" data-h="${esc(handle(p.url) || '')}" aria-label="Agregar ${esc(nom)} al carrito">+</button></div>`; }).join('') + `<button type="submit" class="sds-todos">Ver todos los resultados de “${esc(q)}”</button>`
          : `<p class="sds-nada">No encontramos “${esc(q)}”. Prueba con una marca o un sabor.</p>`;
        caja.hidden = false;
      } catch (e) { if (e.name !== 'AbortError') caja.hidden = true; }
    }
    input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(busca, 140); });
    input.addEventListener('focus', () => { ultima = ''; busca(); });
    input.addEventListener('keydown', (e) => { if (e.key === 'Escape') { caja.hidden = true; input.blur(); } });
    caja.addEventListener('click', async (e) => {
      const pop = e.target.closest('[data-pop]');
      if (pop) { input.value = pop.dataset.pop; input.focus(); busca(); return; }
      const b = e.target.closest('.sds-mas');
      if (!b || b.disabled) return;
      b.disabled = true; b.textContent = '…';
      try {
        const prod = await (await fetch(`${root}products/${b.dataset.h}.js`)).json();
        const v = prod.variants.find((x) => x.available);
        if (!v) throw new Error('Sin existencia');
        const r = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) });
        if (!r.ok) throw new Error('No se pudo agregar');
        const c = await (await fetch(`${root}cart.js`)).json();
        document.querySelectorAll('.cart-counter').forEach((x) => { x.textContent = c.item_count; });
        b.textContent = '✓'; b.classList.add('is-ok');
        window.sdCarrito?.agregado();
      } catch (_) { b.textContent = '+'; b.disabled = false; }
    });
    document.addEventListener('click', (e) => { if (!form.contains(e.target)) caja.hidden = true; });
  });
})();
